import Game from 'common/wxGame.js';
import { substring as substr, runes } from './substr.js';
import 'jsapis/editAddress.js';
import 'jsapis/dispatchEvent.js';
const shake_icon = 'https://res.wx.qq.com/wechatgame/product/cdn/shake-event/share_fdbb2a37.gif';

const fmap = {
  singlemessage: 1,
  groupmessage: 2,
  timeline: 4,
  message: 10
};
const timeMaps = [
  [60, 3600, 0, 1, 2, 3],
  ['分钟前', '小时前', '今天', '昨天', '前天', '天前']
];
const Env = WXGAME.Env;
const wxBridge = WXGAME.WxBridge;
const Str = WXGAME.String;
const JUMP_TIMEOUT = 0;
let _jumping = null;
let _params = {};

export { runes, substr };
export default {
  runes,
  substr,
  left(str, length) {
    let res = runes(`${str}`);
    return res.length > length ? res.slice(0, length - 2).join('') + '...' : str;
  },
  openUrl(url, appid = '', timeout = JUMP_TIMEOUT) {
    console.log('jumping url', url, appid);
    let _ssid = {};
    clearTimeout(_jumping);
    if (appid && typeof appid == 'object' && appid.ssid) {
      _ssid = appid;
    }
    _jumping = setTimeout(() => {
      let p = this.getParams();
      if (p.ssid) {
        url = url.replace('?', `?ssid=${p.ssid}&`);
      }
      url = url.split('#')[0] + '#wechat_redirect';
      if (Env.isWechat) {
        if (window.jsapi_verified) {
          wxBridge.openUrl(`${url}`, _ssid);
        } else {
          wxBridge.verifyJsapi(['openUrl'].concat(wxBridge.apis), function () {
            clearTimeout(_jumping);
            window.jsapi_verified = true;
            wxBridge.openUrl(`${url}`, _ssid);
          });
        }
      } else {
        window.open(`${url}`);
      }
    }, timeout);
  },
  openMiniApp(params, timeout = JUMP_TIMEOUT, cbk = () => {}) {
    clearTimeout(_jumping);
    let req = {
      path: params.path || `pages/club_index/club_index.html?appid=${params.appid}`,
      appid: params.appid,
      targetAppId: params.targetAppId || 'wx98bb879bbb53ad81',
      referrerAppId: 'wx62d9035fd4fd2059',
      envVersion: params.envVersion || 'release'
    };
    if (location.href.indexOf('trialminapp=1') != -1) {
      req.envVersion = 'trial';
    }
    if (Env.isPC && typeof cbk == 'function') {
      setTimeout(function () {
        cbk({ err_msg: 'launchMiniProgram:ok' });
      }, timeout);
      return;
    }
    _jumping = setTimeout(() => {
      if (Env.isWechat) {
        if (window.jsapi_verified) {
          wxBridge.launchMiniProgram(req, cbk);
        } else {
          wxBridge.verifyJsapi(['launchMiniProgram'].concat(wxBridge.apis), function () {
            window.jsapi_verified = true;
            wxBridge.launchMiniProgram(req, cbk);
          });
        }
      } else {
        if (params.appid == 'wx98bb879bbb53ad81') {
          location.href = `https://game.weixin.qq.com/cgi-bin/h5/static/community/club_index.html?appid=${params.appid}#wechat_redirect`;
        }
      }
    }, timeout);
  },
  getSSidFromShare() {
    let p = this.getParams();
    return p.from && p.from in fmap ? fmap[p.from] : 0;
  },
  isFromShare() {
    let p = this.getParams();
    return (p.from && p.from in fmap) || Object.values(fmap).includes(+p.ssid);
  },
  setNavigationBarColor(color) {
    if (Env.isWechat) {
      if (window.jsapi_verified) {
        wxBridge.invoke('setNavigationBarColor', { color }, (res) => {
          console.log('setNavigationBarColor', res);
        });
      } else {
        wxBridge.verifyJsapi(['setNavigationBarColor'].concat(wxBridge.apis), function () {
          window.jsapi_verified = true;
          wxBridge.invoke('setNavigationBarColor', { color }, (res) => {
            console.log('setNavigationBarColor', res);
          });
        });
      }
    } else {
      console.log(` wxBridge.invoke('setNavigationBarColor', { ${color} })`);
    }
  },
  prepareListParams: function (nv = {}) {
    let list = [];
    for (let appid in nv) {
      if (
        typeof appid == 'string' &&
        /^wx[a-z0-9]{16}$/.test(appid) &&
        nv[appid] instanceof Array
      ) {
        let op = { appid, list: [] };
        nv[appid].forEach((i) => {
          if (i.token && i.actid) {
            op.list.push({
              encrypt: i.token,
              act_id: +i.actid
            });
          }
        });
        if (op.list.length > 0) {
          list.push(op);
        }
      }
    }
    return list;
  },
  getParams() {
    if (Object.keys(_params) < 1) {
      Object.assign(_params, Str.strToMap(location.search.substr(1)));
    }
    return _params;
  },
  parseTime: function (t) {
    let n = Math.floor(Date.now() / 1000);
    let ndays = Math.ceil(n / 86400);
    let rdays = Math.ceil(t / 86400);
    let dt = new Date(t * 1000);
    let ds = `${dt.getHours()}:${dt.getMinutes()}`
      .replace(/^(\d:)/, '0$1')
      .replace(/:(\d)$/, ':0$1');
    let rt = ds;
    for (let i = timeMaps[0].length - 1; i > 0; i--) {
      let d = ndays - rdays;
      if (d >= timeMaps[0][i]) {
        rt = `${d <= 2 ? '' : d}${timeMaps[1][i]}${d <= 2 ? ds : ''}`;
        if (d == 0) {
          let h = Math.abs(n - t);
          if (h > timeMaps[0][1]) {
            rt = `${Math.ceil(h / timeMaps[0][1])}${timeMaps[1][1]}`;
          } else if (h <= timeMaps[0][1]) {
            rt = `${Math.ceil(h / timeMaps[0][0])}${timeMaps[1][0]}`;
          }
        }
        break;
      }
    }
    return rt;
  },
  prepareAppInfo: function (appItem = {}) {
    let obj = {};
    Object.keys(appItem).forEach((k) => {
      if (typeof appItem[k] == 'object' && !(appItem[k] instanceof Array)) {
        Object.assign(obj, appItem[k]);
      } else if (typeof appItem[k] == 'string' || typeof appItem[k] == 'number') {
        obj[k] = appItem[k];
      }
    });
    obj.appid = obj.AppID;
    if (Env.isiOS) {
      obj.ioslink = `${obj.appid}://`;
      obj.iosdownurl = obj.DownloadURL;
    } else if (Env.isAndroid) {
      obj.appname = obj.Name;
      obj.pkgname = obj.PackageName;
      obj.androiddownurl = obj.DownloadURL;
      obj.androidpkgsize = obj.AndroidApkSize;
      obj.alternativeurl = obj.AlternativeDownloadURL;
      obj.downloadertype = 1;
      obj.md5sum = obj.AndroidApkMd5;
    }
    return obj;
  },
  openAddress(cbk) {
    wxBridge.editAddress({}, (res) => {
      cbk(true, res);
      // alert(JSON.stringify(res));
      console.error(true, res);
    });
  },
  launchApp(appitem, cbk = false) {
    if (Env.isPC && typeof cbk == 'function') {
      let rets = [3, 6, 11];
      console.log('fake launch game ret');
      cbk(appitem, rets[Math.floor(Math.random() * rets.length)]);
      return;
    }
    if (Env.isiOS || Env.isAndroid) {
      let appinfo = this.prepareAppInfo(appitem);
      Game.app.allinone(appinfo, (ret) => {
        if (typeof cbk == 'function') {
          if (ret == 17 || ret == 3) {
            ret = 23;
          } else if (ret == 6) {
            ret = 22;
          } else if (ret == 11) {
            ret = 44;
          }
          cbk(appitem, ret);
        }
      });
    }
  },
  getUrl(appid, path, ssid = 904) {
    let prefix =
      'https://game.weixin.qq.com/cgi-bin/h5/static/circlecenter/mixed_circle.html?appid=';
    let hasurl = /^https:\/\/game.weixin.qq.com\//i.test(path);
    let ipath = `${prefix}${appid}&wechat_pkgid=circlecenter_mixed_circle&tabid=7&ssid=${ssid}&rpt_allpath=${ssid}`;
    return (hasurl ? path : ipath).split('#')[0] + '#wechat_redirect';
  },
  closeWindow: function (timeout = 0) {
    if (Env.isWechat) {
      setTimeout(() => {
        wxBridge.closeWindow();
      }, timeout);
    } else {
      setTimeout(() => {
        window.close();
      }, timeout);
    }
  },
  setPageTitle: function (title) {
    if (Env.isWechat) {
      if (window.jsapi_verified) {
        wxBridge.invoke('setPageTitle', { title }, (res) => {
          console.log('setPageTitle', res);
        });
      } else {
        wxBridge.verifyJsapi(['setPageTitle'].concat(wxBridge.apis), function () {
          window.jsapi_verified = true;
          wxBridge.invoke('setPageTitle', { title }, (res) => {
            console.log('setPageTitle', res);
          });
        });
      }
    } else {
      document.title = title;
      console.log(` wxBridge.invoke('setPageTitle', {title:"${title}"})`);
    }
  },
  stripKeys(url = '') {
    url = url.replace(
      /\b(uin|pass_ticket|key|skey|abtest_cookie|wx_header|debug|vconsole)=[^&]+/g,
      '&'
    );
    url = url.replace(/&+/g, '&');
    url = url.replace(/&+$/g, '').replace(/\?&/, '?');
    url = url.replace(/#.*$/g, '') + '#wechat_redirect';
    return url;
  },
  getShareData(conf = {}, SE) {
    let app = conf.appitem || {};
    let link = location.href;
    let is_owner = conf.is_owner || conf.is_self;
    let app_name = app.BriefName || app.Name || '';
    let data = {};
    let title = '@微信游戏摇心愿，一起许愿摇出惊喜';
    let desc = '亿万珍稀礼包，等你来摇';
    if (!conf.desc) {
      desc = '千万高价值游戏礼包持续摇出';
    } else {
      let cdesc = `获得了${conf.desc}`;
      if (conf.desc == 1) {
        cdesc = `摇到了${app_name}心愿`;
      }
      title = is_owner
        ? `我在微信游戏摇心愿中${cdesc}`
        : `@${this.left(conf.nickname, 6)} 的${app_name}心愿被我摇中，快来实现吧`;
      desc = !is_owner ? '可实现其中一个心愿哦' : desc;
      conf.icon = SE.cash_icon || conf.icon;
    }
    if (!SE) {
      data = {
        type: 'set_share',
        img_width: '108',
        img_height: '108',
        link: conf.shake_gift,
        title,
        timelineTitle: title,
        desc,
        appid: 'wx62d9035fd4fd2059',
        shareTips: '点击发送给朋友',
        pos: 8,
        img_url: conf.shake_icon || shake_icon
      };
    } else {
      data = {
        img_url: conf.icon || conf.image || shake_icon,
        img_width: '108',
        img_height: '108',
        link: this.stripKeys(link),
        title,
        timelineTitle: title,
        desc,
        appid: 'wx62d9035fd4fd2059',
        shareTips: '点击发送给朋友',
        extInfo: conf.extInfo || {},
        pos: 8
      };
    }
    data.link = data.link.replace(/(\?|&)c=1/g, '$1');
    return data;
  },
  getQrcode() {
    let prefix = location.protocol + '//game.weixin.qq.com/cgi-bin/comm/qrcode?s=3&m=0&d=';
    let jump_url = this.stripKeys(location.href);
    return prefix + encodeURIComponent(jump_url);
  },
  dispatchEvent(param = {}, cbk = (msg) => {}) {
    let p = this.getParams();
    if (!param.token && p.token) {
      param.token = Str.filterXSS(`${p.token}`);
    }
    if (!param.actid && p.actid) {
      param.actid = `${p.actid}`.replace(/[^\d]+/g, '');
    }
    if (!param.appid && p.appid) {
      param.appid = `${p.appid}`.replace(/[^\w]+/g, '');
    }
    let eventName = param.eventName || '__giftGotResultEvent__';
    console.log('dispatchEvent', {
      eventName,
      appId: 'wx62d9035fd4fd2059',
      data: param
    });
    delete param.eventName;
    wxBridge.dispatchEvent(
      {
        eventName,
        appId: 'wx62d9035fd4fd2059',
        data: param
      },
      cbk
    );
  }
};
